export default "__VITE_ASSET__B9yJP9m9__"